import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AccountOverview from '../components/AccountOverview';
const DashboardPage = () => {
    const navigate = useNavigate();
    const handleNavigateToTransfer = () => {
        navigate('/transfer');
    };
    const handleNavigateToProtect = () => {
        navigate('/protect');
    };
    const handleNavigateToRemediation = () => {
        navigate('/remediation');
    };
    return (_jsx("div", { className: "page", children: _jsx(AccountOverview, { onNavigateToTransfer: handleNavigateToTransfer, onNavigateToProtect: handleNavigateToProtect, onNavigateToRemediation: handleNavigateToRemediation }) }));
};
export default DashboardPage;
